export default __webpack_public_path__ + "static/swvl-4-bd6dd1bc6761445f1b731648d0dfda5e.webp";